type QueuedRequestResolver = (token: string) => void;

let isRefreshingToken = false;
let pendingQueue: QueuedRequestResolver[] = [];

export const tokenRefreshQueue = {
  isRefreshing(): boolean {
    return isRefreshingToken;
  },
  start(): void {
    isRefreshingToken = true;
  },
  subscribe(resolver: QueuedRequestResolver): void {
    pendingQueue.push(resolver);
  },
  resolveAll(newAccessToken: string): void {
    pendingQueue.forEach((resolver) => resolver(newAccessToken));
    pendingQueue = [];
    isRefreshingToken = false;
  },
  rejectAll(): void {
    pendingQueue = [];
    isRefreshingToken = false;
  },
};
